import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";

/**
 * Cargador FullStop en 3D — malla GLB realista (escaneo IA del producto real,
 * con el anillo RGB e interior negro en la textura).
 * - Pose base: anillo RGB de frente y algo inclinado, con el conector + botones
 *   asomando al lado/arriba (se ajusta con BASE_ROT).
 * - Posición: a la DERECHA en el hero → se CENTRA al bajar.
 */
useGLTF.preload("/models/charger.glb");

// Pose base (ajustable) para que el anillo mire a cámara como en la foto.
const BASE_ROT_X = -0.18;
const BASE_ROT_Y = 0.42;

export default function ChargerModel({ scrollRef, pointerRef }) {
  const group = useRef();
  const { scene } = useGLTF("/models/charger.glb");

  useFrame(() => {
    const g = group.current;
    if (!g) return;
    const scroll = scrollRef?.current || 0;
    const p = pointerRef?.current || { x: 0, y: 0 };

    // Derecha (hero) → centro (al bajar el primer 45%).
    const t = Math.min(scroll / 0.45, 1);
    const targetX = 1.6 * (1 - t);
    g.position.x += (targetX - g.position.x) * 0.08;

    // Vaivén suave alrededor de la pose base (mantiene el anillo de frente).
    const targetRotY = BASE_ROT_Y + Math.sin(scroll * Math.PI * 2) * 0.16 + p.x * 0.14;
    const targetRotX = BASE_ROT_X - p.y * 0.1;
    g.rotation.y += (targetRotY - g.rotation.y) * 0.08;
    g.rotation.x += (targetRotX - g.rotation.x) * 0.08;
  });

  return (
    <primitive
      ref={group}
      object={scene}
      scale={0.9}
      position={[1.6, 0.05, 0]}
      rotation={[BASE_ROT_X, BASE_ROT_Y, 0]}
    />
  );
}
